import { AppModal } from '@Common/AppModal';
import { Spinner } from '@Common/Spinner';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Elements } from '@stripe/react-stripe-js';
import { stripeOptions } from 'appConstants';
import { SetStateType } from 'commonTypes';
import { FormattedMessage } from 'react-intl';
import { useConfigureStripe } from 'store/subscription/actions';

import { BillingForm } from '../UI';

interface ChangeBillingInfoModalProps {
  open: boolean;
  setOpen: SetStateType<boolean>;
}

export const ChangeBillingInfoModal = ({
  open,
  setOpen,
}: ChangeBillingInfoModalProps) => {
  const { data: stripePromise, isPending } = useConfigureStripe();

  return (
    <AppModal open={open} size="max-w-xl">
      <div className="flex items-center justify-between w-full mb-3">
        <h1 className="text-xl">
          <FormattedMessage id="editBillingInfo" />
        </h1>
        <XMarkIcon
          onClick={() => {
            setOpen(false);
          }}
          className="h-6 w-6 cursor-pointer text-gray-500 md:hover:text-gray-700"
        />
      </div>
      {isPending || !stripePromise ? (
        <Spinner color="bg-primary" />
      ) : (
        <Elements stripe={stripePromise} options={stripeOptions}>
          <BillingForm onSubmit={() => setOpen(false)} submitText="save" />
        </Elements>
      )}
    </AppModal>
  );
};
